// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 1925) return "static/js/1925.774d34418d.js";
  // return url for filenames based on template
  return "static/js/async/" + chunkId + "." + {1333: "b109c1ad18",3945: "4184372a1a",4976: "606e80817c",5728: "98b9cf8418",5942: "3e1f9ccba1",7740: "8b82c4efca",8164: "6cbbc75e56",8454: "10425b219b",9802: "a589af87b0",}[chunkId] + ".js"
}